import { useQuery } from "@tanstack/react-query";

import api from "@/common/utils/api";

export const adminStripeBillingQueryKey = (orgId: string) =>
  ["admin", "org", orgId, "stripe-billing"] as const;

export function useAdminStripeBilling(orgId: string) {
  return useQuery({
    queryKey: adminStripeBillingQueryKey(orgId),
    queryFn: () =>
      api
        .get<"/admin/:orgId/stripe-billing">(`/admin/${orgId}/stripe-billing`)
        .then((res) => res.data),
    enabled: !!orgId,
    refetchOnWindowFocus: false,
  });
}
